import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {routing} from "./app.routing";
import {AppComponent} from "./app.component";
import {LoginComponent} from "./authentication/component/login/login.component";
import {AuthenticationGuard} from "./authentication/guard/authentication.guard";
import {FormsModule} from "@angular/forms";
import {HttpModule, RequestOptions, XHRBackend} from "@angular/http";
import {AuthenticationService} from "./authentication/service/authentication.service";
import {HttpFactory} from "./authentication/service/httpSecure.factory";
import {HttpSecure} from "./authentication/service/httpSecure.service";


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        routing
    ],
    declarations: [
        AppComponent,
        LoginComponent
    ],
    bootstrap: [AppComponent],
    entryComponents: [AppComponent],
    providers: [
        AuthenticationGuard,
        HttpModule,
        AuthenticationService,
        {
            provide: HttpSecure,
            useFactory: HttpFactory,
            deps: [XHRBackend, RequestOptions, AuthenticationService]
        }
    ],
})

export class AppModule {
    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.module.ts